
// JavaScript Document
var $ = jQuery.noConflict();

// $(window).scroll(function() {    
//     var scroll = $(window).scrollTop();

//     if (scroll >= 50) {
//         $(".headerSec").addClass("darkHeader");
//     } else {
//         $(".headerSec").removeClass("darkHeader");
//     }
    
//     if ($(window).width() < 767) {
//         $('.headerSec').removeClass('darkHeader');
//     }

// });

$(document).ready(function () {
	
	$(".sticky-slider").owlCarousel({
  autoplay: true,
  items: 1,
  loop: true,
  nav: true,
  dots: false,
  smartSpeed: 1000,
  autoplaySpeed: 1000,
  mouseDrag: false, // usually better with fade
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  navText: [
    '<i class="fa fa-angle-left" aria-hidden="true"></i>',
    '<i class="fa fa-angle-right" aria-hidden="true"></i>'
  ],
  responsive: {
    0: { items: 1 },
    600: { items: 1 },
    900: { items: 1 },
    1000: { items: 1 }
  }
});

  
	
});	

//----------------------------------------------- 
// --

// wow = new WOW(
//     {
//       animateClass: 'animated',
//       offset:       100,
//       callback:     function(box) {
//         //console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
//       }
//     }
// );
// wow.init();
    
AOS.init();

  // Page loading animation
  $(window).on('load', function() {
    if($('.cover').length){
        $('.cover').parallax({
            imageSrc: $('.cover').data('image'),
            zIndex: '1'
        });
    }

    $("#preloader").animate({
        'opacity': '0'
    }, 600, function(){
        setTimeout(function(){
            $("#preloader").css("visibility", "hidden").fadeOut();
        }, 300);
    });
});

/*Scroll to top when arrow up clicked*/
$(window).scroll(function() {
    var height = $(window).scrollTop();
    if (height > 200) {
        $('#back2Top').fadeIn();
    } else {
        $('#back2Top').fadeOut();
    }
  });
  $(document).ready(function() {
    $("#back2Top").click(function(event) {
        event.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
    });
  
  });
  /*Scroll to top when arrow up clicked END*/

//   $(window).load(function () {
//     $('.dl').hide();
//   });


jQuery(function($) {
    if ($(window).width() > 769) {
      $('.navbar .dropdown').hover(function() {
        $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();
  
      }, function() {
        $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();
  
      });
  
      $('.navbar .dropdown > a').click(function() {
        location.href = this.href;
      });
  
    }
  });
    

  AOS.init({disable: 'mobile'});
  AOS.init({
    disable: function() {
      var maxWidth = 800;
      return window.innerWidth < maxWidth;
    }
  });

/* Top Nav slide down GSAP */
$(document).ready(function(){
	 $('#hamburger').on('click touchstart', function (e) {
		$(this).closest('.header-wrapper').toggleClass('menu-open');
	});
});


    var menu = document.querySelector("#hamburger");
    if (menu) { // always check if it exists
        var tl = gsap.timeline();
        var isOpen = false;

        tl.to("#top-nav", {
            top: 0,
            opacity: 1,
            duration: 0.6,
            visibility: "visible",
        });
        tl.from("#top-nav li", {
            x: 100,
            duration: 0.3,
            stagger: 0.1,
            opacity: 0,
        });
        tl.from("#top-nav .menu-left-img", {
            y: -100,
            duration: 0.2,
            stagger: 0.5,
            opacity: 0,
        });
        tl.from("#top-nav .menu-right-img", {
            x: -500,
            duration: 0.3,
            stagger: 0.1,
            opacity: 0,
        });
        tl.pause();

        menu.addEventListener("click", function() {
         
            if (!isOpen) {
                tl.play();
                isOpen = true;
            } else {
                tl.reverse();
                isOpen = false;
            }
        });
    }


 

 
/*##################### Mega Menu ############################*/

! function (e) {
  "use strict";
  var i = e(window),
      a = e(document);

  e(function () {
      e(".navigation-menu > ul > li:has( > div)").addClass("menu-dropdown-icon"), e(".navigation-menu > ul > li.menu-dropdown-icon").append('<div class="dropworn-arrow"></div>'), e(".navigation-menu > ul > li > div:not(:has(ul))").addClass("normal-sub"), e(".navigation-menu > ul").before('<a href="#" class="menu-mobile">Menu</a>');
      var a = e(".navigation-menu > ul > li"),
          t = e(".menu-mobile");
      a.on("mouseenter mouseleave", function (a) {
          i.width() > parseInt(979) && (e(this).children(".js-nav-dropdown").stop(!0, !1).fadeToggle(150), e(this).children(".dropworn-arrow").stop(!0, !1).fadeToggle(150), a.preventDefault())
      }), a.on("click", function () {
          i.width() <= parseInt(979) && (e(this).children(".js-nav-dropdown").fadeToggle(150), e(this).children(".dropworn-arrow").hide())
      }), t.on("click", function (i) {
          e(".navigation-menu > ul").toggleClass("show-on-mobile"), i.preventDefault()
      })
  });

}(jQuery);


/*##################### End Mega Menu ############################*/


// document.querySelectorAll(".custom-add-to-cart-form").forEach(function(form) {
//     form.addEventListener("submit", function(e) {
//       e.preventDefault();

//       let cartDrawer = document.querySelector("cart-drawer");
//       const formData = new FormData(form);

//       // Build body in the format your theme expects
//       const body = {
//         items: [{
//           id: formData.get("id"),
//           quantity: 1
//         }],
//         sections: cartDrawer.getSectionsToRender().map(section => section.id),
//         sections_url: window.location.pathname
//       };

//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(body)
//       })
//       .then(res => res.json())
//       .then(data => {
//         // ✅ Refresh the cart drawer contents
//         cartDrawer.renderContents(data);
//         cartDrawer.classList.remove("is-empty");
//         cartDrawer.open();
//       })
//       .catch(err => console.error("Add to cart error:", err));
//     });
//   });




